import { render, staticRenderFns } from "./LoadMoreProducts.vue?vue&type=template&id=84f40dac&"
import script from "./LoadMoreProducts.vue?vue&type=script&lang=js&"
export * from "./LoadMoreProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports